// client/src/api/companionService.js — R51 v2/v5
// Génération compagnon (4 humeurs même seed) + avatar + historique.

import api from './api';

const API_URL = '/auth';

// 1 image par requête : mood + seed (le seed est renvoyé et réutilisé par le
// client pour les humeurs suivantes → même personnage).
export async function companionGenerate(prompt, kind, mood, seed) {
  const response = await api.post(
    `${API_URL}/companion/generate`,
    { prompt, kind, mood, ...(seed != null ? { seed } : {}) },
    { timeout: 120000 }
  );
  return response.data;
}

export async function companionCommit(kind, images) {
  const body = kind === 'avatar' ? { kind, image: images } : { kind, images };
  const response = await api.post(`${API_URL}/companion/commit`, body, { timeout: 60000 });
  return response.data;
}

export async function companionActivate(kind, id) {
  const response = await api.post(`${API_URL}/companion/activate`, { kind, id }, { timeout: 30000 });
  return response.data;
}

export async function companionDelete(kind, id) {
  const response = await api.post(`${API_URL}/companion/delete`, { kind, id }, { timeout: 30000 });
  return response.data;
}

// Découpe de fond ML (sidecar rembg) — retourne un Blob PNG alpha
export async function companionMatting(file) {
  const response = await api.post(`${API_URL}/companion/matting`, { file }, { responseType: 'blob', timeout: 120000 });
  return response.data;
}
